/**
 * Polyfills pour le navigateur (exécuté avant le reste de l'app).
 * Définit process pour éviter "process is not defined" dans le bundle.
 */
if (typeof process === 'undefined' && typeof window !== 'undefined') {
  window.process = {
    env: {}
  };
}
